import React from 'react';
import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Typography, Link, AppBar, Toolbar } from '@mui/material';
import AccountCircle from '@mui/icons-material/AccountCircle';
import Button from '@mui/material/Button';
import Menu, { menuClasses } from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { LoginClickHandler, LogoutClickHandler } from './Login';
import { GFORM } from '../App/ApplicationConfig';
const classes = {
    root: {
        flexGrow: 1,
    },
    menuLink: {
        marginRight: '16px',
    },
    linkTypography: {
        fontSize: '16px',
    },
    login: {
        marginRight: '0px',
        marginLeft: 'auto',
        display: 'flex',
        flexDirection: 'row',
    },
    appBar: {
        minHeight: '40px',
        height: '40px',
    },
    toolBar: {
        minHeight: '40px !important',
        height: '40px',
    },
    menu: {
        marginTop: '45px',
    },
    buttonStyle: {
        color: 'white',
        textTransform: 'none',
        fontSize: '16px',
        fontWeight: 400,
    },
};
const LinkBehavior = (to) => 
// eslint-disable-next-line react/display-name,@typescript-eslint/no-explicit-any
React.forwardRef((props, ref) => (React.createElement(RouterLink, Object.assign({ ref: ref, to: to }, props))));
const navItemLabels = [
    {
        path: '/',
        label: 'Home',
    },
    {
        path: '/project',
        label: 'Data Discovery',
    },
];
const AccountMenu = ({ user }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const serviceUrl = user.notebookURL;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    if (!user || !user.preferred_username) {
        return null;
    }
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: handleClick, startIcon: React.createElement(AccountCircle, { style: { fontSize: 30 } }), endIcon: React.createElement(ExpandMoreIcon, { style: { fontSize: 25 } }), style: {
                marginRight: '5px',
            }, sx: classes.buttonStyle, variant: 'text' },
            React.createElement("span", null,
                user.preferred_username,
                " ",
                !user.registered && '(unregistered)')),
        React.createElement(Menu, { id: 'AccountMenu', anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, sx: Object.assign(Object.assign({}, classes.menu), { [`& .${menuClasses.paper}`]: { top: '87px !important' } }) },
            React.createElement(MenuItem, { disabled: user.registered, 
                // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
                component: RouterLink, to: '/register', onClick: handleClose }, "Register account"),
            React.createElement(MenuItem, { disabled: !user.notebookId, onClick: () => {
                    window.open(serviceUrl, '_blank');
                } }, "My notebook"),
            React.createElement(MenuItem, { onClick: LogoutClickHandler }, "Logout"))));
};
export const NavLink = ({ navItem }) => {
    const location = useLocation();
    const [shortPathName, setShortPathName] = React.useState('');
    React.useEffect(() => {
        setShortPathName(location.pathname.replace('/c4i-frontend', ''));
    }, [location.pathname]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Link, { key: navItem.path, color: 'inherit', component: LinkBehavior(navItem.path), underline: 
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            (navItem.path === '/' && shortPathName === '') ||
                shortPathName === navItem.path ||
                shortPathName === `${navItem.path}/`
                ? 'always'
                : 'none', sx: classes.menuLink },
            React.createElement(Typography, { onClick: () => {
                    window.location.hash = '';
                }, sx: classes.linkTypography }, navItem.label))));
};
const HelpMenu = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (React.createElement("div", null,
        React.createElement(Button, { onClick: handleClick, style: {
                marginLeft: '-15px',
            }, sx: classes.buttonStyle, variant: 'text' }, "Help"),
        React.createElement(Menu, { id: 'HelpMenu', anchorEl: anchorEl, keepMounted: true, open: Boolean(anchorEl), onClose: handleClose, sx: { [`& .${menuClasses.paper}`]: { top: '87px' } } },
            React.createElement(MenuItem, { onClick: handleClose },
                React.createElement(NavLink, { navItem: { label: 'C4I Portal', path: '/helpC4I' } })),
            React.createElement(MenuItem, { onClick: handleClose },
                React.createElement(NavLink, { navItem: { label: 'C4I Workspace', path: '/helpSwirrl' } })))));
};
export const NavigationBar = ({ user }) => {
    return (React.createElement("div", { style: classes.root },
        React.createElement(AppBar, { position: 'static', sx: classes.appBar },
            React.createElement(Toolbar, { sx: classes.toolBar },
                navItemLabels.map((navItem) => (React.createElement(NavLink, { key: navItem.label, navItem: navItem }))),
                React.createElement(HelpMenu, null),
                React.createElement(Typography, { sx: classes.linkTypography },
                    React.createElement(Link, { sx: classes.menuLink, href: GFORM, target: '_blank', rel: 'noopener', color: 'inherit', underline: 'none' }, "Feedback")),
                React.createElement(NavLink, { navItem: { label: 'Register', path: '/register' } }),
                React.createElement(NavLink, { navItem: { label: 'Privacy Notice', path: '/privacy-notice' } }),
                (user === null || user === void 0 ? void 0 : user.preferred_username) ? (React.createElement("div", { style: classes.login },
                    React.createElement(AccountMenu, { user: user }))) : (React.createElement("div", { style: classes.login },
                    React.createElement(Button, { size: 'small', sx: classes.buttonStyle, variant: 'text', onClick: LoginClickHandler }, "Login")))))));
};
export default NavigationBar;
